<template>
  <v-snackbar
    v-model="alerta"
    :color="color"
    bottom
    rounded="pill"
    :content-class="snackbarClass"
  >
    {{ textAlert }}
  </v-snackbar>
</template>

<script>
export default {
  props: {
    alert: Boolean,
    color: String,
    textAlert: String,
  },

  data() {
    return {
      alerta: this.alert,
    };
  },
  computed: {
    snackbarClass() {
      return "text-center";
    },
  },

  watch: {
    alert(newAlertValue) {
      this.alerta = newAlertValue;

      if (newAlertValue) {
        setTimeout(() => {
          this.alerta = false;
        }, 2500);
      }
    },
  },
};
</script>
